import "./about.css";
import ImageCard from "../../cards/imageCard/ImageCard";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";
import Button from "../../cards/buttons/Button";
import { profile } from "../../Object Files/profile";

const About = () => {
  const handleClick = () => {
    window.location.hash = "#contact";
    document.getElementById("name")?.focus();
  };

  const leftAboutVariant = {
    hidden: { x: -40, opacity: 0 },
    show: {
      x: 0,
      opacity: 1,
      transition: { type: "tween", ease: "easeOut", duration: 0.45 },
    },
  };
  const rightAboutVariant = {
    hidden: { x: 40, opacity: 0 },
    show: {
      x: 0,
      opacity: 1,
      transition: { type: "tween", ease: "easeOut", duration: 0.45 },
    },
  };

  return (
    <section id="about">
      <motion.div
        className="about-main-container"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className="about-container">
          <motion.div variants={leftAboutVariant}>
            <ImageCard
              img="/assets/cartoon-profile-Photoroom.webp"
              fallback="/assets/cartoon-profile.webp"
              alt={`${profile.name} — ${profile.title}`}
            />
          </motion.div>

          <motion.div className="about-sub-cont" variants={rightAboutVariant}>
            <h1 className="abt-header alt-text">About Me</h1>

            <div className="column">
              <p className="about-name">{profile.name}</p>
              <p className="alt-text about-role">{profile.title}</p>
              <p className="about-experience">
                {profile.experienceYears} years · {profile.location}
              </p>
            </div>

            <hr className="short-hr" />

            <p className="about-me-text">
              I am a <strong>backend-leaning full-stack engineer</strong> with a
              Microbiology degree and a track record of shipping real products.
              I care about clear API contracts, reliable data models, and systems
              that stay maintainable after launch.
            </p>

            <p className="about-highlights">
              <span className="highlight-item">🚀 {profile.backendYears}</span>{" "}
              building APIs, auth, payments & real-time features
              <br />
              <span className="highlight-item">🏗️ Production</span> — Gruve
              ticketing & Giglink marketplace (live in Africa)
              <br />
              <span className="highlight-item">⚡ Stack</span> — Node, NestJS,
              Prisma, PostgreSQL, MongoDB, AWS, Stripe, Socket.IO
              <br />
              <span className="highlight-item">🎓 Foundation</span> — ALX/Holberton
              backend track & ongoing open-source on GitHub
            </p>

            <p className="about-me-text">
              I pair solid backend work with thoughtful React front ends when the
              product needs it. I am looking for teams that value ownership,
              code review, and shipping dependable services — not just pretty
              landing pages.
              <span
                className="get-in-touch-btn"
                onClick={handleClick}
                onKeyDown={(e) => e.key === "Enter" && handleClick()}
                role="button"
                tabIndex={0}
              >
                {" "}
                Let&apos;s talk about your next backend challenge.
              </span>
            </p>

            <div className="flex left_align interests-row">
              Interests:
              <Typewriter
                options={{
                  strings: [
                    "🎶 Music",
                    "⚽ Football",
                    "🎥 Movies",
                    "✍️ Writing",
                    "📖 Reading",
                  ],
                  autoStart: true,
                  loop: true,
                  cursor: "|",
                  pauseFor: 2000,
                  delay: 28,
                }}
              />
            </div>

            <Button
              href={profile.cvUrl}
              className="btn alt-text"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download CV
              <i className="fa-solid fa-download" aria-hidden="true"></i>
            </Button>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default About;
